import { DocumentPageEntity } from "./document-page.entity";

export interface IHistory {
  push(action: TemplateHistoryAction, label: string): void;
}

export class TemplateHistory {
  private _past: TemplateHistorySnapshot[] = [];
  private _future: TemplateHistorySnapshot[] = [];

  get canUndo(): boolean {
    return this._past.length > 1;
  }

  get canRedo(): boolean {
    return this._future.length > 0;
  }

  getHistory(): readonly TemplateHistorySnapshot[] {
    return this._past;
  }

  getFuture(): readonly TemplateHistorySnapshot[] {
    return this._future;
  }

  pushSnapshot(snapshot: TemplateHistorySnapshot): void {
    const tail = this._past[this._past.length - 1];
    if (tail && tail.fingerprint === snapshot.fingerprint) return;
    this._past.push(snapshot);
    this._future = [];
  }

  undo(): TemplateHistorySnapshot | null {
    if (this._past.length <= 1) return null;
    const popped = this._past.pop();
    if (!popped) return null;
    this._future.push(popped);
    return this._past[this._past.length - 1];
  }

  redo(): TemplateHistorySnapshot | null {
    const next = this._future.pop();
    if (!next) return null;
    this._past.push(next);
    return next;
  }

  reset(): void {
    this._past = [];
    this._future = [];
  }
}

export enum TemplateHistoryAction {
  ADD_TOKEN = "ADD_TOKEN",
  UPDATE_TOKEN = "UPDATE_TOKEN",
  REMOVE_TOKEN = "REMOVE_TOKEN",
  MOVE_TOKEN = "MOVE_TOKEN",
  ADD_PAGE = "ADD_PAGE",
  CLEAR_PAGE = "CLEAR_PAGE",
  PAGE_CHANGE = "PAGE_CHANGE"
}

export class TemplateHistorySnapshot {
  actionName: TemplateHistoryAction;
  subjectTitle: string;
  pages: DocumentPageEntity[];
  activePageIndex: number;
  fingerprint: string;

  constructor(snapshotState: {
    actionName: TemplateHistoryAction;
    subjectTitle: string;
    pages: DocumentPageEntity[];
    activePageIndex: number;
  }) {
    this.actionName = snapshotState.actionName;
    this.subjectTitle = snapshotState.subjectTitle;
    this.pages = snapshotState.pages.map((page) => page.clone());
    this.activePageIndex = snapshotState.activePageIndex;
    this.fingerprint = this.computeFingerprint();
  }

  private computeFingerprint(): string {
    return `${this.activePageIndex}|${this.pages.map((page) => page.fingerprint).join("|")}`;
  }
}
